import React, { useEffect, useState, useRef, useMemo } from 'react';
import { connect } from 'react-redux';
import MesTable from '../../../../components/Table/MesTable';
import { FormattedMessage } from 'react-intl';
import useInfiniteScroll from '../../../../components/common/useInfiniteScroll';

function SignageReceivers({receivers}) {
  const [data, setData] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [totalDataCount, setTotalDataCount] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [dataLoaded, setDataLoaded] = useState(false);
  const [selectedIds, setSelectedIds] = useState({});
  const [sortByCol, setSortByCol] = useState('name');
  const [sortByAsc, setSortByAsc] = useState(false);
  const [startIndexForTable, setStartIndexForTable] = useState(0);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [receiversData, setReceiversData] = useState([]);
  const tableRef = useRef();
  const tableWrapperRef = useRef();
  
  const dataMap = useMemo(() => ({
    data: {},
    ids: [],
    sortedIds: [],
    filteredIds: [],
    selectedIds: {}
  }), []);

  const { generateDataSlice, sortMap, setSortBy } = useInfiniteScroll({
    dataMap,
    setData,
    setStartIndexForTable,
    startIndexForTable,
    pageSize: 100,
    sortByCol,
    setSortByCol,
    sortByAsc,
    setSortByAsc,
    tableWrapperRef,
    searchValue,
    tableRef,
    rowHeight: 48,
  });

  const loadReceivers = async () => {
    dataMap.data = {};
    dataMap.ids = [];
    dataMap.sortedIds = [];
    dataMap.filteredIds = [];
    dataMap.selectedIds = {};

    try {
      receivers.forEach((item) => {
        dataMap.data[item.mac] = {
          id: item.mac,
          name: item.name,
          status: item.status,
        };
      });
      console.log(receivers, dataMap.data);
      dataMap.filteredIds = Object.keys(dataMap.data);
      dataMap.ids = Object.keys(dataMap.data);
      setReceiversData(receivers);
      setDataCount(dataMap.ids.length);
      setTotalDataCount(dataMap.ids.length);
      setDataLoaded(true);
    } catch (err) {
      setError(err.message);
      setDataLoaded(true);
    }
  };

  useEffect(() => {
    loadReceivers();
    // eslint-disable-next-line
  }, [receivers]);

  const tableColumnArray = [
    {
      Header: "NAME",
      id: 'name',
      accessor: 'name',
      isVisible: true,
    },
    {
      Header: "STATUS",
      id: 'status',
      accessor: 'status',
      isVisible: true,
    }
  ];

  useEffect(() => {
    if (dataLoaded) {
      if (searchValue !== '') {
        tableRef.current.search(dataMap);
      } else {
        sortMap(dataMap);
        setData(generateDataSlice(dataMap));
      }
    }
  }, [sortByCol, sortByAsc, dataLoaded, dataMap, receiversData]);

  const tableProps = {
    pageType: 'SignageReceivers',
    modalId: '',
    columns: tableColumnArray,
    data,
    setData,
    dataMap,
    generateDataSlice,
    sortMap,
    dataCount,
    setDataCount,
    totalDataCount,
    setSortBy,
    sortByCol,
    setSortByCol,
    sortByAsc,
    setSortByAsc,
    error,
    setError,
    success,
    setSuccess,
    startIndex: startIndexForTable,
    selectedIds,
    setSelectedIds,
    searchValue,
    setSearchValue,
    tableRef,
    tableWrapperRef,
    dataLoaded,
    initialContainerHeight: '280px',
    simpleTable: true
  };

  return (
    <div className="modal modal-mse fade" id="signageReceiversModal" tabIndex="-1" aria-labelledby="signageReceiversModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content modal-mes-content">
          <div className="modal-header modal-mes-header" style={{ backgroundColor: '#347BFA' }}>
            <h5 className="modal-title modal-mes-title"><FormattedMessage id="RECEIVERS" /></h5>
            <button id="closeImportModal" type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <MesTable {...tableProps} />
          </div>
          <div className="modal-footer modal-mes-footer d-flex align-items-center">
            <button id="closeBtn" type="button" className="btn btn-primary but-darkblue" data-bs-dismiss="modal"><FormattedMessage id="CLOSE" /></button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect()(SignageReceivers);